import cx from 'classnames';
import { useSelector, useDispatch } from 'react-redux';
import { FormEvent, KeyboardEventHandler, useContext, useEffect, useRef, useState } from 'react';
import _ from 'lodash';

import { guid } from 'src/services/util';
import { sendMessage } from 'src/legacy/redux/actions/smallTalk';
import { AppContext } from 'src/components/app/contexts/appContext';
import { DealRoomContext } from '../../../context';

import styles from "./styles.module.scss";

const ChatInput: React.FC = () => {
  const dispatch = useDispatch();
  const { smallTalk } = useContext(AppContext);
  const { dealRoom } = useContext(DealRoomContext);

  const dealRoomId = _.get(dealRoom, 'id', '');

  const activeChatUser = useSelector((state: any) => {
    return _.get(state, `dealRooms.dealRoom.${dealRoomId}.engage.activeChatUser.item`, null);
  });
  const channelName = _.get(activeChatUser, 'uuid', []);

  const me = useSelector((state: any) => {
    return _.get(state, 'users.me', null);
  });
  const myUuid = _.get(me, 'id', '');

  const textAreaRef = useRef<HTMLTextAreaElement>(null);
  const formRef = useRef<HTMLFormElement>(null);
  const [message, setMessage] = useState('');

  const onTextChange = (text: string) => {
    setMessage(text);
  }

  const handleSend = (event: FormEvent) => {
    event.preventDefault();

    const trimmedMessage = message.trim();

    if (trimmedMessage === '') {
      return;
    }

    const request = {
      channel: channelName[0],
      message: {
        id: guid(),
        type: "MESSAGE",
        text: message,
        timestamp: new Date().getTime(),
        fingerPrint: "",
        sharedUrl: '',
        sender: {
          chatUser: _.get(activeChatUser, 'id', ''),
          id: me.id,
          name: `${_.get(me, 'firstName') || ''} ${_.get(me, 'lastName') || ''}`,
          type: 'user',
        }
      },
      uuid: myUuid,
    }

    dispatch(sendMessage(smallTalk.client, request) as any);
    setMessage('');
  }

  const handleKeyDown: KeyboardEventHandler<HTMLTextAreaElement> = (event) => {
    if (event.code === 'Enter' && event.shiftKey === false) {
      event.preventDefault();
      formRef?.current?.requestSubmit();
    }
  }

  return (
    <form className={styles.inputContainer} onSubmit={handleSend} ref={formRef}>
      <div className={styles.inputSection}>
        <textarea
          className={styles.textArea}
          value={message}
          ref={textAreaRef}
          onChange={(event) => onTextChange(event.target.value)}
          onKeyDown={handleKeyDown}
          placeholder='Type something...'
        />
      </div>
      <div className={styles.divider}></div>
      <button type='submit' className={styles.sendButton}>
        <div className={styles.icon}>
          <i className={cx('paperflite-send', styles.sendIcon)} />
        </div>
      </button>
    </form>
  )
}

export default ChatInput;